import React from 'react';
import {
  Box,
  Heading,
  Text,
  VStack,
  HStack,
  useColorModeValue,
  Icon,
  Button,
  Flex,
} from '@chakra-ui/react';
import { FaArrowRight } from 'react-icons/fa';
import { SolutionCardProps } from '../types';

const SolutionCardPresentation: React.FC<SolutionCardProps> = ({ 
  title, 
  description, 
  icon, 
  benefits, 
  isReversed = false 
}) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  
  return (
    <Flex
      direction={{ base: 'column', md: isReversed ? 'row-reverse' : 'row' }}
      bg={cardBg}
      borderRadius="lg"
      overflow="hidden"
      boxShadow="lg"
      borderWidth="1px"
      borderColor={borderColor}
      my={6}
    >
      <Box 
        bg="brand.primary.dark" 
        color="white" 
        p={6} 
        display="flex" 
        alignItems="center" 
        justifyContent="center"
        w={{ base: 'full', md: '25%' }}
      >
        <Box fontSize="3em">
          {icon}
        </Box>
      </Box>
      
      <Box p={6} w={{ base: 'full', md: '75%' }}>
        <Heading as="h3" size="md" mb={3} color="brand.primary.dark">
          {title}
        </Heading>
        <Text mb={4} color="gray.600" fontSize="sm">
          {description}
        </Text>
        
        <Box>
          <Text fontWeight="bold" mb={2} fontSize="sm">Key Benefits:</Text>
          <VStack align="flex-start" spacing={1}>
            {benefits.map((benefit: string, index: number) => (
              <HStack key={index} align="flex-start">
                <Box color="brand.primary.base" mt={0.5}>
                  <Icon as={FaArrowRight} boxSize={2} />
                </Box>
                <Text color="gray.600" fontSize="xs">{benefit}</Text>
              </HStack>
            ))}
          </VStack>
        </Box>
        
        <Button 
          variant="link" 
          colorScheme="teal" 
          mt={4} 
          size="sm"
          rightIcon={<FaArrowRight />}
        >
          Learn more
        </Button>
      </Box>
    </Flex>
  );
};

export default SolutionCardPresentation;